export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Hledat',
  catalogHeaderTitle: 'Podrobnosti',
  catalogDetailsCurtainCopyOptionTitle: 'Kopírovat odkaz',
  catalogDetailsLinkCopiedAlertText: 'Odkaz byl zkopírován!',
  catalogDetailsCurtainFlagOptionTitle: 'Nahlásit obsah',
  catalogDetailsFlagCurtainTitle: 'Nahlásit',
  catalogReportedCurtainContent: 'Obsah byl nahlášen',
  catalogWantBuy: 'Chcete koupit {item} od {app}',
  catalogInterestedIn: '{link}'
}
